import type { ReactElement } from "react";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import { StyledParenthesisedContent } from "app/pages/sales-intelligence/common-components/styles";
import { StyledTruncatedInnerText } from "./styles";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

type Props = {
    text: Readonly<Translatable> | string;
    count: number;
    isFullSelection?: boolean;
};

function DropdownLabelWithCount(props: Props) {
    const { text, count, isFullSelection = false } = props;

    const renderRemainingOptions = (): ReactElement | null => {
        if (count > 0) {
            return <span>&nbsp;+{count}</span>;
        }

        return null;
    };

    const content = is.string(text) ? (
        <StyledTruncatedInnerText>{text}</StyledTruncatedInnerText>
    ) : (
        <I18n
            translatable={text}
            element={StyledTruncatedInnerText}
        />
    );

    return (
        <>
            {content}
            {isFullSelection ? (
                <StyledParenthesisedContent>{count}</StyledParenthesisedContent>
            ) : (
                renderRemainingOptions()
            )}
        </>
    );
}

export default DropdownLabelWithCount;
